import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-dates/initialize';

import { SingleDatePicker } from 'react-dates';
import { Wrapper } from './DatePicker.styles';

export class DatePicker extends Component {
    static displayName = 'DatePicker';

    static propTypes = {
        selectDate: PropTypes.func,
        date: PropTypes.object,
        autoFocus: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            focused: props.autoFocus,
        };

        this.onDateChange = this.onDateChange.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { displayFormat } = this.props;
        return (
            this.props.date !== nextState.date ||
            this.state.focused !== nextState.focused ||
            displayFormat !== nextProps.displayFormat
        );
    }

    onDateChange(date) {
        this.props.selectDate(new Date(date));
    }

    onFocusChange({ focused }) {
        this.setState({ focused });
    }

    render() {
        const { focused } = this.state;

        // autoFocus and initialDate are helper props for the example wrapper but are not
        // props on the SingleDatePicker itself and thus, have to be omitted.
        const {
            autoFocus,
            date,
            displayFormat,
            initialDate,
            selectDate,
            readOnly,
            ...rest
        } = this.props;

        return (
            <Wrapper>
                <SingleDatePicker
                    {...rest}
                    id="date_input"
                    date={date}
                    focused={focused}
                    noBorder
                    onDateChange={this.onDateChange}
                    onFocusChange={this.onFocusChange}
                    numberOfMonths={1}
                    displayFormat={displayFormat || 'MMMM D, YYYY'}
                    small
                    hideKeyboardShortcutsPanel
                    firstDayOfWeek={1}
                    readOnly={readOnly}
                />
            </Wrapper>
        );
    }
}
